/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-08-10",
    versionChannel: "nightly",
    buildDate: "2023-08-10T00:23:43.496Z",
    commitHash: "fb01473bb3a096d9afca4e464ce6961a45b09045",
};
